import { useQuery } from "@tanstack/react-query";
import { REPLACEMENT_ORDER_TYPE } from "@/services/shipment-options/shipment-options.constants";
import { ShipmentOptionsService } from "@/services/shipment-options/shipment-options-service";
import type { ShipmentDeliveryOption } from "@/services/shipment-options/shipment-options.types";

const SHIPMENT_OPTIONS_QUERY_KEY = ["shipment-options"] as const;

const shipmentOptionsService = new ShipmentOptionsService();

export interface UseShipmentOptionsParams {
  make: string;
  model: string;
}

export const useShipmentOptions = ({ make, model }: UseShipmentOptionsParams) => {
  const query = useQuery({
    queryKey: [...SHIPMENT_OPTIONS_QUERY_KEY, make, model],
    queryFn: () => shipmentOptionsService.getShipmentOptions({ make, model, orderType: REPLACEMENT_ORDER_TYPE }),
    enabled: Boolean(make && model),
    staleTime: Infinity,
  });

  const deliveryOptions: ShipmentDeliveryOption[] = query.data?.deliveryOptions ?? [];

  return {
    deliveryOptions,
    isLoading: query.isLoading,
    isSuccess: query.isSuccess,
    isError: query.isError,
    error: query.error,
    isEmpty: query.isSuccess && deliveryOptions.length === 0,
    refetch: query.refetch,
  };
};
